export default __webpack_public_path__ + "../staticImages/mobile-app-banner-icon.png";